import { render, staticRenderFns } from "./configBudgets.vue?vue&type=template&id=ffaecd60&scoped=true"
import script from "./configBudgets.vue?vue&type=script&lang=js"
export * from "./configBudgets.vue?vue&type=script&lang=js"
import style0 from "./configBudgets.vue?vue&type=style&index=0&id=ffaecd60&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffaecd60",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins/workspace/web-page/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ffaecd60')) {
      api.createRecord('ffaecd60', component.options)
    } else {
      api.reload('ffaecd60', component.options)
    }
    module.hot.accept("./configBudgets.vue?vue&type=template&id=ffaecd60&scoped=true", function () {
      api.rerender('ffaecd60', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "found/views/tpm/views/banquet_management/banquet_gd_details/form/components/configBudgets.vue"
export default component.exports